import React from 'react';

const SmallPulse = props => {
	const { className, renderProp, ...moreProps } = props;
	return (
		<div className={`bb__pulse-svg ${className}`} {...moreProps}>
			<div className="bb__pulse-svg__circle bb__first-circle" />
			<div className="bb__pulse-svg__circle bb__second-circle" />
			<div className="bb__pulse-svg__circle bb__third-circle" />
			{typeof renderProp !== 'undefined' ? renderProp() : ''}
		</div>
	);
};

export default SmallPulse;
